import { h, render } from 'preact';
import $ from 'jquery';
import axios from 'axios';
import type from './libs/type';
import route from './route';

import ProductDownload from './components/ProductDownload';

// layout-header__main_search-mode
const $page = $('.downloads-page');
const $stepMap = $page.find('.downloads-page__step-map');
const $searchForm = $page.find('.downloads-page__search');

const $directionSelect = $stepMap.find('select[name="direction"]');
const $categorySelect = $stepMap.find('select[name="category"]');
const $lineSelect = $stepMap.find('select[name="line"]');
const $modelSelect = $stepMap.find('select[name="model"]');

const dataPropertyMap = {
    category: 'categories',
    line: 'lines'
}

const tree = window.tree;

const getNextSelect = function(select)
{
    const nextSelectName = $(select).data('relative');

    if(nextSelectName) {
        const $nextSelect = $stepMap.find(`select[name="${nextSelectName}"]`);
        if($nextSelect.length) {
            console.info('getNextSelect 2', nextSelectName, $nextSelect.get(0));
            return $nextSelect.get(0);
        }
    }

    return undefined;
}

const emptySelect = function(select)
{
    $(select).empty();
}

const enableSelect = function(select)
{
    $(select).removeAttr('disabled');
}

const disableSelect = function(select)
{
    $(select).attr('disabled', 'disabled');
}

const resetSelectChain = function(select)
{
    let nextSelect = select

let i = 0;
    while(nextSelect)
    {

if(i > 10) {
    break;
}
console.info('nextSelect '+i+'.1', nextSelect, i);

        if(nextSelect) {
            disableSelect(nextSelect);
            emptySelect(nextSelect);
        }

        nextSelect = getNextSelect(nextSelect);

console.info('nextSelect '+i+'.2', nextSelect, i);
i++;
    }
}

const loadDataToSelect = function(select, data) {

    if(!select) {
        return;
    }
    const $select = $(select);
    const nameAttr = $select.attr('name');

    // при загрузке данных в селект всегда очищаем его
    $select.empty();

    if(type.isNotEmptyArray(data)) {

        const placeholder = $select.attr('placeholder');
        if(placeholder) {
            $select.prepend(`<option value="__placeholder__">${placeholder}</option>`)
        }

        data.forEach(item => {
            const $option = $(`<option value="${item.id}">${item.title}</option>`);

            const $nextSelect = $(getNextSelect($select));
            if($nextSelect.length) {
                const nextNameAttr = $nextSelect.attr('name');
                const nextProperty = dataPropertyMap[nextNameAttr];

                if(nextProperty && type.isNotEmptyArray(item[nextProperty])) {
                    $option.data('data', item[nextProperty]);
                }
            }

            $select.append($option);
        });

        enableSelect($select);
    }
    else {
        let url = '';
        if(nameAttr === 'model') {   
            url = route('download.product', {line_id: $lineSelect.val()});
        }
        else if(nameAttr === 'line') {
            url = route('download.product', {category_id: $categorySelect.val()});
        }

        if(url) {
            axios.get(url)
                .then(response => {
                    console.info('response', response);

                    if(type.isNotEmptyArray(response.data)) {
                        loadDataToSelect($modelSelect.get(0), response.data);
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        }

        disableSelect($select);
    }
}

const insertProductComponent = function(props, $container) {
    $container.parent().find('#product_download').remove();

    $container.after('<div id="product_download"></div>')
                        
    const wrapper = document.getElementById('product_download');

    if(wrapper) {
        wrapper.innerHTML = '';

        render(<ProductDownload {...props} />, wrapper);

        if(typeof(document.body.scrollIntoView) === 'function') {
            const container = document.getElementById('product_download');
            if(container) {
                container.scrollIntoView({
                    block: "start", behavior: "smooth"
                })
            }
        }
    }
}

const initStepMap = function()
{
    if(!$stepMap.length)
    {
        return
    }

    loadDataToSelect($stepMap.find('select:first').get(0), window.tree);

    $stepMap.on('change', 'select', function(e, data) {
        var nextSelect = getNextSelect(this);
        if(nextSelect) {
            console.info('change nextSelect', nextSelect);
            // загружаем данные в селект
            loadDataToSelect(nextSelect, $(this).find('option:selected').data('data'));
            //resetSelectChain(getNextSelect(nextSelect));
        }
        else if(this.name === 'model') {
            const url = route('download.product.show', $(this).val());
            axios.get(url)
                .then(response => {
                    console.info('response', response.data);

                    window.history.pushState({}, 'JKJKJ', url);
                    if(type.isNotEmptyPlainObject(response.data)) {
                        let $container = $(this).closest('.downloads-page__group');
                        insertProductComponent(response.data, $container);
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        }
    })
}

const initSearchForm = function() {
    const $serialError = $('#serial_error');

    $searchForm.on('submit', function(e) {
        e.preventDefault();

        $.ajax({
            url: $searchForm.attr('action'),
            data: $searchForm.serialize(),
            type: $searchForm.attr('method') || 'get',
            dataType: 'json',
            success: function(response) {
                if(type.isNotEmptyPlainObject(response) && response.status !== false) {
                    $serialError.hide();

                    let $container = $searchForm.closest('.downloads-page__group');
                    insertProductComponent(response, $container);
                }
                else {
                    $serialError.show();
                }
            },
            error: function(response) {
                console.info('error', arguments);
                $serialError.show();
            }
        });
    });
}


const init = function()
{
    initStepMap();
    initSearchForm();
}

export default init;